"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _moment = _interopRequireDefault(require("moment"));

var _functionalButton = require("@widget/functional-button");

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _Countdown = _interopRequireDefault(require("./Countdown"));

var _OnAuthRefresh = _interopRequireDefault(require("./OnAuthRefresh"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function ModifyForm(_ref) {
  var handleSubmit = _ref.handleSubmit,
      valid = _ref.valid,
      pristine = _ref.pristine,
      onRefresh = _ref.onRefresh,
      isDisabled = _ref.isDisabled,
      onFinished = _ref.onFinished,
      token = _ref.token;

  try {
    var _isAuthTimerFinished = function isAuthTimerFinished() {
      setIsAuthCounterFinished(false);
    };

    var inProcess = (0, _reactRedux.useSelector)(_functionalButton.selectInSubmitProcess);

    var _useState = (0, _react.useState)(true),
        _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
        isAuthCounterFinished = _useState2[0],
        setIsAuthCounterFinished = _useState2[1];

    var now = (0, _moment["default"])().format();
    var timestamp = (0, _moment["default"])(token['nextRefreshTime']).format('X');
    var authTimestamp = (0, _moment["default"])(token['nextAuthTime']).format('X');
    (0, _react.useEffect)(function () {
      if (token['nextAuthTime'] && (0, _moment["default"])(token['nextAuthTime']).isAfter(now)) {
        setIsAuthCounterFinished(true);
      }
    }, [token]);
    return /*#__PURE__*/_react["default"].createElement("form", {
      className: _defaultModule["default"]['dialog'],
      onSubmit: handleSubmit,
      "data-locator": 'token2fa.form'
    }, isAuthCounterFinished ? /*#__PURE__*/_react["default"].createElement(_OnAuthRefresh["default"], {
      authTimestamp: authTimestamp,
      isAuthTimerFinished: function isAuthTimerFinished() {
        return _isAuthTimerFinished();
      }
    }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['title'],
      "data-locator": 'confirm-twoFA.title'
    }, "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u0432\u044B\u0432\u043E\u0434\u0430 \u0441\u0440\u0435\u0434\u0441\u0442\u0432"), token['description'] && /*#__PURE__*/_react["default"].createElement("header", {
      className: _defaultModule["default"]['dialog__header'],
      "data-locator": 'Payout.dialog.header',
      dangerouslySetInnerHTML: {
        __html: token['description']
      }
    }), /*#__PURE__*/_react["default"].createElement("article", {
      className: _defaultModule["default"]['dialog__content'],
      "data-locator": 'payout.dialog.content'
    }, /*#__PURE__*/_react["default"].createElement("section", {
      className: _defaultModule["default"]['form']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.InputField, {
      type: 'code',
      label: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434 \u0438\u0437 SMS",
      name: "code",
      autoFocus: true
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['refresh']
    }, isDisabled ? /*#__PURE__*/_react["default"].createElement(_Countdown["default"], {
      interval: 1000,
      eventTime: timestamp,
      finished: onFinished,
      label: 'Запросить новый код через',
      locator: 'nextRefreshTime'
    }) : /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['refresh__link'],
      "data-locator": 'payout.code.refresh',
      onClick: onRefresh
    }, "\u0417\u0430\u043F\u0440\u043E\u0441\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u043A\u043E\u0434"))), /*#__PURE__*/_react["default"].createElement("footer", {
      className: _defaultModule["default"]['dialog__controls']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Button, {
      "data-locator": "payout.code.submit",
      type: "submit",
      mode: "success",
      inProcess: inProcess,
      disabled: !valid || pristine
    }, "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C"))));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = ModifyForm;
exports["default"] = _default;